/*
 * Candidate Shifts Tab Messages
 *
 * This contains all the text for the Candidate Shifts Tab component.
 */

import { defineMessages } from 'react-intl';
export const scope =
  'src.pages.CandidatesDetailsPage.components.CandidateShiftsTab';

export default defineMessages({
  searchInputPlaceholder: {
    id: `${scope}.searchInputPlaceholder`,
    defaultMessage: 'Project Search',
  },
  jobIdColumnLabel: {
    id: `${scope}.jobIdColumnLabel`,
    defaultMessage: 'JID',
  },
  jobNameColumnLabel: {
    id: `${scope}.jobNameColumnLabel`,
    defaultMessage: 'Job Name',
  },
  projectNameColumnLabel: {
    id: `${scope}.projectNameColumnLabel`,
    defaultMessage: 'Project Name',
  },
  dateRangeAndTimeColumnLabel: {
    id: `${scope}.dateRangeAndTimeColumnLabel`,
    defaultMessage: 'Date Range and Time',
  },
  jobTypeColumnLabel: {
    id: `${scope}.jobTypeColumnLabel`,
    defaultMessage: 'Job Type',
  },
  ratingColumnLabel: {
    id: `${scope}.ratingColumnLabel`,
    defaultMessage: 'Rating',
  },
});
